var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 18,
    rx: 8,
    ry: 7,
    fill: "#797CAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1592 16.0836C30.611 13.6777 29.3982 11.4416 27.66 9.63203C25.9219 7.82242 23.7288 6.51265 21.3327 5.85311C18.9365 5.19356 16.4343 5.21097 14.1135 5.90333C11.7926 6.59569 9.74715 7.93495 8.21187 9.76733C6.67659 11.5997 5.71375 13.8509 5.4339 16.2626C5.15405 18.6742 5.56853 21.1485 6.62976 23.4013C7.69098 25.6541 9.35593 27.5942 11.4334 28.9988C13.511 30.4034 15.9169 31.2155 18.3749 31.342L18.3966 24.9131C17.1563 24.8493 15.9423 24.4395 14.894 23.7307C13.8457 23.022 13.0056 22.0431 12.4702 20.9063C11.9347 19.7696 11.7255 18.5211 11.8668 17.3042C12.008 16.0874 12.4938 14.9514 13.2685 14.0268C14.0432 13.1022 15.0753 12.4265 16.2463 12.0771C17.4174 11.7278 18.68 11.719 19.889 12.0518C21.0981 12.3846 22.2047 13.0454 23.0817 13.9586C23.9588 14.8717 24.5708 16 24.8474 17.2139L31.1592 16.0836Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.ecf272c2a085b221848202f916dea072.svg";
export { ForwardRef as ReactComponent };